// Do not modify this file manually! This file was generated by "npm run generate:icon" script

import React, { SVGProps } from "react";

interface Props {
  name: IconName | string;
  className?: string;
  svgAttributes?: SVGProps<SVGSVGElement>;
  altText?: string;
}

const IconOld: React.FC<Props> = ({ name, className, svgAttributes, altText }) => {
  switch (name) {
    /**
     * === SIMPLE ICONS
     * DO NOT DELETE - refactor later when possible.
     * Used now in: 'Alert.tsx'.
     *
     * */
    case "info-circle-grey":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 12C1 5.94772 5.94772 1 12 1C18.0523 1 23 5.94772 23 12C23 18.0523 18.0523 23 12 23C5.94772 23 1 18.0523 1 12ZM12 3C7.05228 3 3 7.05228 3 12C3 16.9477 7.05228 21 12 21C16.9477 21 21 16.9477 21 12C21 7.05228 16.9477 3 12 3Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9961 10L10.9961 16H9.5V18L10.9961 18H12.9961H14.5V16H12.9961L12.9961 10H10.9961Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2539 8C13.2539 8.69036 12.6943 9.25 12.0039 9.25L11.9949 9.25C11.3046 9.25 10.7449 8.69036 10.7449 8C10.7449 7.30964 11.3046 6.75 11.9949 6.75L12.0039 6.75C12.6943 6.75 13.2539 7.30964 13.2539 8Z"
          />
        </svg>
      );

    case "info-circle-red":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.25 12C1.25 6.08579 6.08579 1.25 12 1.25C17.9142 1.25 22.75 6.08579 22.75 12C22.75 17.9142 17.9142 22.75 12 22.75C6.08579 22.75 1.25 17.9142 1.25 12ZM12 2.75C6.91421 2.75 2.75 6.91421 2.75 12C2.75 17.0858 6.91421 21.25 12 21.25C17.0858 21.25 21.25 17.0858 21.25 12C21.25 6.91421 17.0858 2.75 12 2.75Z"
            fill="#E00000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2461 17.75L11.2461 10.25H12.7461L12.7461 17.75H11.2461Z"
            fill="#E00000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.25 17.75H9.75V16.25H14.25V17.75Z"
            fill="#E00000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0039 8C13.0039 8.55228 12.5562 9 12.0039 9H11.9949C11.4426 9 10.9949 8.55228 10.9949 8C10.9949 7.44772 11.4426 7 11.9949 7H12.0039C12.5562 7 13.0039 7.44772 13.0039 8Z"
            fill="#E00000"
          />
        </svg>
      );

    case "cross-mark":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.58124 1.33657C8.04449 1.14405 8.58829 1 9.10001 1H14.9C15.4117 1 15.9555 1.14405 16.4188 1.33657C16.8822 1.52916 17.3668 1.81256 17.7271 2.1729L17.0249 2.87513L17.7271 2.1729L21.8271 6.27291C22.1874 6.63324 22.4708 7.11782 22.6634 7.58124C22.8559 8.04449 23 8.58829 23 9.10001V14.9C23 15.4117 22.8559 15.9555 22.6634 16.4188C22.4708 16.8822 22.1874 17.3668 21.8271 17.7271L17.7271 21.8271C17.3668 22.1874 16.8822 22.4708 16.4188 22.6634C15.9555 22.8559 15.4117 23 14.9 23H9.10001C8.58829 23 8.04449 22.8559 7.58124 22.6634C7.11781 22.4708 6.63323 22.1874 6.27289 21.8271L6.98 21.12L6.27289 21.8271L2.1729 17.7271C1.81256 17.3668 1.52917 16.8822 1.33657 16.4188C1.14405 15.9555 1 15.4117 1 14.9V9.10001C1 8.58829 1.14405 8.04449 1.33657 7.58124C1.52917 7.11782 1.81256 6.63324 2.1729 6.27291L6.27289 2.1729L6.98 2.88L6.27289 2.1729C6.63323 1.81256 7.11781 1.52916 7.58124 1.33657ZM8.34876 3.18343C8.04218 3.31084 7.80676 3.46745 7.6871 3.58711L3.58711 7.68712L2.88 6.98001L3.58711 7.68712C3.46745 7.80678 3.31084 8.0422 3.18343 8.34878C3.05595 8.65552 3 8.93173 3 9.10001V14.9C3 15.0683 3.05595 15.3445 3.18343 15.6512C3.31084 15.9578 3.46745 16.1932 3.58711 16.3129L7.6871 20.4129C7.80676 20.5325 8.04218 20.6892 8.34876 20.8166C8.65552 20.944 8.93172 21 9.10001 21H14.9C15.0683 21 15.3445 20.944 15.6512 20.8166C15.9578 20.6892 16.1932 20.5325 16.3129 20.4129L20.4129 16.3129C20.5325 16.1932 20.6892 15.9578 20.8166 15.6512C20.944 15.3445 21 15.0683 21 14.9V9.10001C21 8.93173 20.944 8.65552 20.8166 8.34878C20.6892 8.0422 20.5325 7.80678 20.4129 7.68712L16.3129 3.58711C16.1932 3.46745 15.9578 3.31084 15.6512 3.18343C15.3445 3.05595 15.0683 3 14.9 3H9.10001C8.93172 3 8.65552 3.05595 8.34876 3.18343Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4142 12L16.9142 8.50003L15.5 7.08582L12 10.5858L8.5 7.08582L7.08578 8.50003L10.5858 12L7.08578 15.5L8.5 16.9142L12 13.4142L15.5 16.9142L16.9142 15.5L13.4142 12Z"
          />
        </svg>
      );

    case "check-circle":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9996 3.00037C7.02927 3.00037 3 7.02963 3 12C3 16.9703 7.02927 20.9996 11.9996 20.9996C16.97 20.9996 20.9992 16.9703 20.9992 12C20.9992 7.02963 16.97 3.00037 11.9996 3.00037ZM1 12C1 5.92506 5.9247 1.00037 11.9996 1.00037C18.0745 1.00037 22.9992 5.92506 22.9992 12C22.9992 18.0749 18.0745 22.9996 11.9996 22.9996C5.9247 22.9996 1 18.0749 1 12Z"
            fill="#267C29"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6642 9.17126L11.2865 15.5377C10.8959 15.9277 10.2632 15.9274 9.87292 15.5371L6.33582 12L7.75003 10.5858L10.5807 13.4164L16.2513 7.7558L17.6642 9.17126Z"
            fill="#267C29"
          />
        </svg>
      );

    /**
     * === FLAGS
     * DO NOT DELETE - refactor later when possible.
     * Used now in: 'Exchange Rates Detail' table.
     *
     * */
    case "flag_icon_hu":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38712)">
            {" "}
            <path
              d="M0.995188 10.4348C0.352063 12.1681 0 14.0428 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5651L16 22.9565L31.0048 21.5651C31.6479 19.8319 32 17.9571 32 16C32 14.0428 31.6479 12.1681 31.0048 10.4348L16 9.04346L0.995188 10.4348Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M16.0001 0C9.12073 0 3.25599 4.342 0.995361 10.4348H31.005C28.7442 4.342 22.8796 0 16.0001 0Z"
              fill="#D80027"
            />{" "}
            <path
              d="M16.0001 32.0002C22.8796 32.0002 28.7442 27.6582 31.005 21.5654H0.995361C3.25599 27.6582 9.12073 32.0002 16.0001 32.0002Z"
              fill="#6DA544"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38712">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_jp":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38700)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M16 22.9565C19.8419 22.9565 22.9565 19.8419 22.9565 16C22.9565 12.158 19.8419 9.04346 16 9.04346C12.158 9.04346 9.04346 12.158 9.04346 16C9.04346 19.8419 12.158 22.9565 16 22.9565Z"
              fill="#D80027"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38700">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_ru":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38736)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M31.0048 21.5649C31.648 19.8316 32 17.9569 32 15.9998C32 14.0426 31.648 12.1679 31.0048 10.4346H0.995188C0.352063 12.1679 0 14.0426 0 15.9998C0 17.9569 0.352063 19.8316 0.995188 21.5649L16 22.9563L31.0048 21.5649Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M15.9999 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117C3.2558 27.6582 9.12049 32.0002 15.9999 32.0002Z"
              fill="#D80027"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38736">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_ch":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38754)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#D80027"
            />{" "}
            <path
              d="M24.3477 13.2176H18.7825V7.65234H13.2173V13.2176H7.6521V18.7828H13.2173V24.348H18.7825V18.7828H24.3477V13.2176Z"
              fill="#F0F0F0"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38754">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_pl":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38724)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16" fill="#D80027" />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38724">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_au":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38665)">
            {" "}
            <path
              d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0037 16 0.0018125 16 0C24.8365 0 32 7.1635 32 16Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M15.9573 15.9998H16.0001C16.0001 15.9853 16.0001 15.9715 16.0001 15.957C15.9858 15.9713 15.9716 15.9856 15.9573 15.9998Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M16 8.34781C16 5.5325 16 3.68769 16 0H15.9973C7.162 0.0014375 0 7.16425 0 15.9999H8.34781V11.2992L13.0486 15.9999H15.9572C15.9716 15.9857 15.9858 15.9714 16.0001 15.9571C16.0001 14.8792 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M8.09467 2.08691C5.59223 3.51185 3.51185 5.59223 2.08691 8.09467V16H6.26085V6.26092V6.26085H16C16 4.94442 16 3.69029 16 2.08691H8.09467Z"
              fill="#D80027"
            />{" "}
            <path
              d="M16 14.0322L10.3155 8.34768H8.3479C8.3479 8.34762 8.3479 8.34768 8.3479 8.34768L16 15.9997H16C16 15.9997 16 14.6432 16 14.0322Z"
              fill="#D80027"
            />{" "}
            <path
              d="M9.64972 18.7827L10.5278 20.6188L12.5108 20.1605L11.6228 21.9919L13.2174 23.2565L11.232 23.704L11.2375 25.7392L9.64972 24.4659L8.06197 25.7392L8.06753 23.704L6.08203 23.2565L7.67672 21.9919L6.78859 20.1605L8.77166 20.6188L9.64972 18.7827Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M23.9552 22.2607L24.3943 23.1788L25.3858 22.9496L24.9417 23.8653L25.7391 24.4976L24.7463 24.7214L24.7491 25.739L23.9552 25.1023L23.1613 25.739L23.1641 24.7214L22.1714 24.4976L22.9687 23.8653L22.5247 22.9496L23.5161 23.1788L23.9552 22.2607Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M19.8708 12.522L20.3098 13.4401L21.3013 13.2108L20.8573 14.1265L21.6546 14.7588L20.6619 14.9826L20.6646 16.0002L19.8708 15.3635L19.0769 16.0002L19.0796 14.9826L18.0869 14.7588L18.8842 14.1265L18.4402 13.2108L19.4317 13.4401L19.8708 12.522Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M23.9552 6.95654L24.3943 7.87467L25.3858 7.64548L24.9418 8.56117L25.739 9.19342L24.7463 9.41723L24.7491 10.4349L23.9552 9.79817L23.1613 10.4349L23.1641 9.41723L22.1714 9.19342L22.9686 8.56117L22.5247 7.64548L23.5161 7.87467L23.9552 6.95654Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M27.5231 11.1304L27.9621 12.0485L28.9536 11.8192L28.5096 12.7349L29.3069 13.3672L28.3142 13.5911L28.3169 14.6086L27.5231 13.972L26.7293 14.6086L26.7319 13.5911L25.7393 13.3672L26.5366 12.7349L26.0926 11.8192L27.084 12.0485L27.5231 11.1304Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M24.972 16L25.3173 17.0629H26.4349L25.5307 17.7198L25.8762 18.7826L24.972 18.1257L24.0678 18.7826L24.4132 17.7198L23.509 17.0629H24.6266L24.972 16Z"
              fill="#F0F0F0"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38665">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_hr":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38694)">
            {" "}
            <path
              d="M32 16.0001C32 14.043 31.6479 12.1682 31.0048 10.4349L16 9.73926L0.995188 10.4349C0.352063 12.1682 0 14.043 0 16.0001C0 17.9573 0.352063 19.8321 0.995188 21.5653L16 22.261L31.0048 21.5654C31.6479 19.8321 32 17.9573 32 16.0001Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M15.9999 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117C3.2558 27.6582 9.12049 32.0002 15.9999 32.0002Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 15.9999 0C9.12049 0 3.2558 4.342 0.995117 10.4348Z"
              fill="#D80027"
            />{" "}
            <path
              d="M20.174 11.1304H17.3914L17.8552 7.65205L19.7102 6.26074L21.5652 7.65205V10.4347L20.174 11.1304Z"
              fill="#338AF3"
            />{" "}
            <path
              d="M11.8261 11.1304H14.6087L14.1449 7.65205L12.2898 6.26074L10.4348 7.65205V10.4347L11.8261 11.1304Z"
              fill="#338AF3"
            />{" "}
            <path
              d="M17.855 11.1304H14.1448V7.65205L15.9999 6.26074L17.855 7.65205V11.1304Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M10.4348 10.4351V18.0872C10.4348 19.9092 11.3149 21.5296 12.6724 22.5454L13.6464 22.3017L14.8754 23.5381C15.2388 23.613 15.6149 23.6524 16.0001 23.6524C16.3832 23.6524 16.7574 23.6135 17.1189 23.5394L18.5218 22.3712L19.3276 22.5432C20.6845 21.5274 21.5653 19.9087 21.5653 18.0872V10.4351H10.4348Z"
              fill="#F0F0F0"
            />{" "}
            <path d="M10.4348 10.4346H12.6609V12.6606H10.4348V10.4346Z" fill="#D80027" />{" "}
            <path d="M14.887 10.4346H17.113V12.6606H14.887V10.4346Z" fill="#D80027" />{" "}
            <path d="M19.3391 10.4346H21.5652V12.6606H19.3391V10.4346Z" fill="#D80027" />{" "}
            <path d="M12.6609 12.6606H14.887V14.8867H12.6609V12.6606Z" fill="#D80027" />{" "}
            <path d="M17.113 12.6606H19.3391V14.8867H17.113V12.6606Z" fill="#D80027" />{" "}
            <path d="M10.4348 14.8862H12.6609V17.1123H10.4348V14.8862Z" fill="#D80027" />{" "}
            <path d="M12.6609 17.1123H14.887V19.3384H12.6609V17.1123Z" fill="#D80027" />{" "}
            <path d="M14.887 14.8862H17.113V17.1123H14.887V14.8862Z" fill="#D80027" />{" "}
            <path d="M19.3391 14.8862H21.5652V17.1123H19.3391V14.8862Z" fill="#D80027" />{" "}
            <path d="M17.113 17.1123H19.3391V19.3384H17.113V17.1123Z" fill="#D80027" />{" "}
            <path d="M14.887 19.3384H17.113V21.5644H14.887V19.3384Z" fill="#D80027" />{" "}
            <path
              d="M12.6608 19.3384H10.5784C10.7694 20.1659 11.1449 20.9231 11.6597 21.5644H12.6608V19.3384Z"
              fill="#D80027"
            />{" "}
            <path
              d="M19.3391 21.5644H20.3401C20.8551 20.9231 21.2305 20.1658 21.4215 19.3384H19.3391V21.5644Z"
              fill="#D80027"
            />{" "}
            <path
              d="M12.6609 21.5645V22.5358C13.3083 23.023 14.065 23.3723 14.887 23.5399V21.5645H12.6609Z"
              fill="#D80027"
            />{" "}
            <path
              d="M17.113 21.5645V23.5399C17.9351 23.3724 18.6917 23.023 19.3391 22.5358V21.5645H17.113Z"
              fill="#D80027"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38694">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_dk":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38682)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M12.5218 13.9131H31.8645C30.8418 6.06262 24.1292 0 16 0C14.8053 0 13.6417 0.132063 12.5217 0.380313V13.9131H12.5218Z"
              fill="#D80027"
            />{" "}
            <path
              d="M8.34787 13.9129V1.94531C3.95456 4.34244 0.809435 8.73938 0.135498 13.9129H8.34787V13.9129Z"
              fill="#D80027"
            />{" "}
            <path
              d="M8.3478 18.0869H0.135498C0.809435 23.2605 3.95456 27.6574 8.34787 30.0545L8.3478 18.0869Z"
              fill="#D80027"
            />{" "}
            <path
              d="M12.5217 18.087V31.6197C13.6417 31.8679 14.8053 32 16 32C24.1292 32 30.8418 25.9374 31.8645 18.0869H12.5217V18.087Z"
              fill="#D80027"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38682">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_gb":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38766)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M3.30758 6.25879C2.05077 7.89398 1.10308 9.77866 0.55127 11.8261H8.87489L3.30758 6.25879Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M31.449 11.826C30.8972 9.77866 29.9494 7.89398 28.6927 6.25879L23.1255 11.826H31.449Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M0.55127 20.1743C1.10314 22.2217 2.05083 24.1064 3.30758 25.7415L8.87471 20.1743H0.55127Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M25.7413 3.30764C24.1061 2.05083 22.2215 1.10314 20.1741 0.55127V8.87483L25.7413 3.30764Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M6.25903 28.6926C7.89422 29.9494 9.77891 30.8971 11.8263 31.449V23.1255L6.25903 28.6926Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M11.8262 0.55127C9.77885 1.10314 7.89416 2.05083 6.25903 3.30758L11.8262 8.87477V0.55127Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M20.1741 31.449C22.2214 30.8971 24.1061 29.9494 25.7413 28.6927L20.1741 23.1255V31.449Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M23.1255 20.1743L28.6927 25.7416C29.9494 24.1064 30.8972 22.2217 31.449 20.1743H23.1255Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2926 0 14.5962 0.0465 13.9131 0.135438V13.9129V13.913H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7074 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2926 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7074 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z"
              fill="#D80027"
            />{" "}
            <path
              d="M20.1738 20.1739L27.3136 27.3136C27.642 26.9854 27.9552 26.6422 28.2541 26.2865L22.1415 20.1738H20.1738V20.1739Z"
              fill="#D80027"
            />{" "}
            <path
              d="M11.8261 20.1738H11.826L4.68628 27.3135C5.01453 27.6419 5.35772 27.9551 5.71347 28.254L11.8261 22.1413V20.1738Z"
              fill="#D80027"
            />{" "}
            <path
              d="M11.8261 11.826V11.8258L4.68635 4.68604C4.35797 5.01429 4.04472 5.35747 3.74585 5.71322L9.85854 11.8259H11.8261V11.826Z"
              fill="#D80027"
            />{" "}
            <path
              d="M20.1738 11.8264L27.3136 4.68653C26.9854 4.35816 26.6422 4.04491 26.2865 3.74609L20.1738 9.85879V11.8264Z"
              fill="#D80027"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38766">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_se":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38748)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M12.5218 13.9131H31.8645C30.8418 6.06262 24.1292 0 16 0C14.8054 0 13.6417 0.132063 12.5217 0.380313V13.9131H12.5218Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M8.34787 13.9129V1.94531C3.95449 4.34244 0.809435 8.73938 0.135498 13.9129H8.34787V13.9129Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M8.3478 18.0869H0.135498C0.809435 23.2605 3.95449 27.6574 8.34787 30.0545L8.3478 18.0869Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M12.5217 18.087V31.6197C13.6417 31.8679 14.8054 32 16 32C24.1292 32 30.8418 25.9374 31.8645 18.0869H12.5217V18.087Z"
              fill="#0052B4"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38748">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_no":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38718)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M0.55127 20.1738C1.47702 23.6088 3.51733 26.5859 6.26096 28.694V20.1738H0.55127Z"
              fill="#D80027"
            />{" "}
            <path
              d="M14.6089 31.939C15.0675 31.9785 15.5313 31.9999 16.0002 31.9999C23.3926 31.9999 29.613 26.9861 31.449 20.1738H14.6089V31.939Z"
              fill="#D80027"
            />{" "}
            <path
              d="M31.449 11.8261C29.613 5.01381 23.3926 0 16.0002 0C15.5313 0 15.0675 0.021375 14.6089 0.060875V11.8261H31.449Z"
              fill="#D80027"
            />{" "}
            <path
              d="M6.26096 3.30615C3.51733 5.41428 1.47702 8.39134 0.55127 11.8263H6.26096V3.30615Z"
              fill="#D80027"
            />{" "}
            <path
              d="M31.8646 13.9131H12.5218H12.5218V0.380371C11.0431 0.708246 9.64131 1.23968 8.34781 1.9455V13.913V13.9131H0.135438C0.046375 14.5962 0 15.2927 0 16.0001C0 16.7074 0.046375 17.4039 0.135438 18.087H8.34775H8.34781V30.0546C9.64131 30.7603 11.0431 31.2919 12.5218 31.6197V18.0872V18.0871H31.8646C31.9535 17.4039 32 16.7074 32 16.0001C32 15.2927 31.9535 14.5962 31.8646 13.9131Z"
              fill="#0052B4"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38718">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_bg":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38671)">
            {" "}
            <path
              d="M32 16.0001C32 14.043 31.648 12.1682 31.0048 10.4349L16 9.73926L0.995188 10.4349C0.352063 12.1682 0 14.043 0 16.0001C0 17.9573 0.352063 19.8321 0.995188 21.5653L16 22.261L31.0048 21.5654C31.648 19.8321 32 17.9573 32 16.0001Z"
              fill="#496E2D"
            />{" "}
            <path
              d="M15.9999 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117C3.2558 27.6582 9.12049 32.0002 15.9999 32.0002Z"
              fill="#D80027"
            />{" "}
            <path
              d="M0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 15.9999 0C9.12049 0 3.2558 4.342 0.995117 10.4348Z"
              fill="#F0F0F0"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38671">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_us":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38742)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M15.3044 15.9996H32.0001C32.0001 14.5555 31.8076 13.1565 31.4489 11.8257H15.3044V15.9996Z"
              fill="#D80027"
            />{" "}
            <path
              d="M15.3044 7.65196H29.6517C28.6723 6.05371 27.4199 4.64103 25.9598 3.47803H15.3044V7.65196Z"
              fill="#D80027"
            />{" "}
            <path
              d="M16 31.9997C19.7656 31.9997 23.2267 30.6982 25.9598 28.5215H6.04028C8.77341 30.6982 12.2345 31.9997 16 31.9997Z"
              fill="#D80027"
            />{" "}
            <path
              d="M2.34846 24.3478H29.6517C30.438 23.0647 31.0478 21.6622 31.4489 20.1738H0.55127C0.952332 21.6622 1.56214 23.0647 2.34846 24.3478Z"
              fill="#D80027"
            />{" "}
            <path
              d="M7.4115 2.49863H8.86956L7.51331 3.48394L8.03137 5.07825L6.67519 4.09294L5.319 5.07825L5.7665 3.70094C4.57237 4.69562 3.52575 5.861 2.66325 7.1595H3.13044L2.26712 7.78669C2.13262 8.01106 2.00362 8.239 1.88 8.47031L2.29225 9.73913L1.52313 9.18031C1.33194 9.58537 1.15706 9.99956 0.999875 10.4224L1.45406 11.8204H3.13044L1.77419 12.8057L2.29225 14.4L0.936063 13.4147L0.123687 14.0049C0.042375 14.6586 0 15.3243 0 16H16C16 7.1635 16 6.12175 16 0C12.8393 0 9.89281 0.916875 7.4115 2.49863ZM8.03137 14.4L6.67519 13.4147L5.319 14.4L5.83706 12.8057L4.48081 11.8204H6.15719L6.67519 10.2261L7.19319 11.8204H8.86956L7.51331 12.8057L8.03137 14.4ZM7.51331 8.14481L8.03137 9.73913L6.67519 8.75381L5.319 9.73913L5.83706 8.14481L4.48081 7.1595H6.15719L6.67519 5.56519L7.19319 7.1595H8.86956L7.51331 8.14481ZM13.7705 14.4L12.4143 13.4147L11.0581 14.4L11.5762 12.8057L10.2199 11.8204H11.8963L12.4143 10.2261L12.9323 11.8204H14.6087L13.2524 12.8057L13.7705 14.4ZM13.2524 8.14481L13.7705 9.73913L12.4143 8.75381L11.0581 9.73913L11.5762 8.14481L10.2199 7.1595H11.8963L12.4143 5.56519L12.9323 7.1595H14.6087L13.2524 8.14481ZM13.2524 3.48394L13.7705 5.07825L12.4143 4.09294L11.0581 5.07825L11.5762 3.48394L10.2199 2.49863H11.8963L12.4143 0.904312L12.9323 2.49863H14.6087L13.2524 3.48394Z"
              fill="#0052B4"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38742">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_ro":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38730)">
            {" "}
            <path
              d="M15.9999 0C14.0428 0 12.168 0.352063 10.4347 0.995188L9.73901 16L10.4346 31.0048C12.168 31.648 14.0428 32 15.9999 32C17.957 32 19.8318 31.648 21.5651 31.0048L22.2608 16L21.5651 0.995188C19.8318 0.352063 17.957 0 15.9999 0V0Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M32 15.9999C32 9.12049 27.658 3.2558 21.5652 0.995117V31.0048C27.658 28.7441 32 22.8794 32 15.9999Z"
              fill="#D80027"
            />{" "}
            <path
              d="M10.4348 31.0047V0.995117C4.342 3.2558 0 9.12049 0 15.9999C0 22.8794 4.342 28.7441 10.4348 31.0047Z"
              fill="#0052B4"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38730">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_tr":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38760)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#D80027"
            />{" "}
            <path
              d="M15.3448 13.0737L16.6576 14.8828L18.7837 14.1934L17.4688 16.0009L18.7814 17.8099L16.6561 17.1179L15.3413 18.9254L15.3427 16.6904L13.2173 15.9984L15.3434 15.309L15.3448 13.0737Z"
              fill="#F0F0F0"
            />{" "}
            <path
              d="M11.7621 20.5216C9.26483 20.5216 7.24033 18.4971 7.24033 15.9998C7.24033 13.5026 9.26483 11.4781 11.7621 11.4781C12.5407 11.4781 13.2733 11.675 13.913 12.0216C12.9095 11.0402 11.5372 10.4346 10.023 10.4346C6.94933 10.4346 4.45776 12.9262 4.45776 15.9998C4.45776 19.0733 6.94939 21.5649 10.023 21.5649C11.5373 21.5649 12.9096 20.9593 13.913 19.9779C13.2733 20.3246 12.5407 20.5216 11.7621 20.5216Z"
              fill="#F0F0F0"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38760">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_eu":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38688)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#0052B4"
            />{" "}
            <path
              d="M16 6.26074L16.5181 7.85505H18.1944L16.8382 8.84037L17.3562 10.4347L16 9.4493L14.6438 10.4347L15.1619 8.84037L13.8057 7.85505H15.482L16 6.26074Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M9.1134 9.11321L10.6071 9.87422L11.7925 8.68896L11.5301 10.3446L13.0238 11.1057L11.3681 11.3679L11.1059 13.0237L10.3448 11.53L8.68921 11.7923L9.87452 10.607L9.1134 9.11321Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M6.26099 16L7.8553 15.482V13.8057L8.84055 15.1619L10.4349 14.6439L9.44949 16L10.4349 17.3562L8.84055 16.8382L7.8553 18.1944V16.5181L6.26099 16Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M9.1134 22.8864L9.87446 21.3927L8.68921 20.2074L10.3449 20.4698L11.1058 18.9761L11.3681 20.6318L13.0238 20.894L11.5303 21.6551L11.7925 23.3107L10.6071 22.1254L9.1134 22.8864Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M16 25.7388L15.4819 24.1444H13.8057L15.1619 23.1591L14.6438 21.5649L16 22.5502L17.3562 21.5649L16.8382 23.1591L18.1944 24.1444H16.518L16 25.7388Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M22.8866 22.8864L21.3929 22.1255L20.2076 23.3108L20.4699 21.655L18.9763 20.894L20.6319 20.6318L20.8942 18.9761L21.6552 20.4698L23.3108 20.2074L22.1255 21.3928L22.8866 22.8864Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M25.7392 16L24.1449 16.5181V18.1944L23.1596 16.8382L21.5654 17.3562L22.5507 16L21.5654 14.6439L23.1597 15.1619L24.1449 13.8057V15.482L25.7392 16Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M22.8866 9.11315L22.1256 10.6069L23.3109 11.7922L21.6551 11.5298L20.8942 13.0235L20.6319 11.3678L18.9763 11.1055L20.4699 10.3445L20.2076 8.68896L21.393 9.87422L22.8866 9.11315Z"
              fill="#FFDA44"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38688">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_cn":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_20915_38677)">
            {" "}
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#D80027"
            />{" "}
            <path
              d="M8.75625 9.7373L10.1375 13.9873H14.6062L10.9937 16.6186L12.375 20.8686L8.75625 18.2436L5.1375 20.8686L6.525 16.6186L2.90625 13.9873H7.375L8.75625 9.7373Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M18.9687 24.7812L17.9124 23.4812L16.35 24.0874L17.2562 22.6812L16.2 21.3749L17.8187 21.8062L18.7312 20.3999L18.8187 22.0749L20.4437 22.5062L18.8749 23.1062L18.9687 24.7812Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M21.0687 20.9687L21.5687 19.3687L20.2 18.3999L21.875 18.3749L22.3687 16.7749L22.9125 18.3624L24.5875 18.3437L23.2437 19.3437L23.7812 20.9312L22.4125 19.9624L21.0687 20.9687Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M23.9 11.7435L23.1625 13.2497L24.3625 14.4185L22.7063 14.181L21.9688 15.681L21.6813 14.031L20.0188 13.7935L21.5063 13.0122L21.2188 11.356L22.4188 12.5247L23.9 11.7435Z"
              fill="#FFDA44"
            />{" "}
            <path
              d="M19.0124 7.18115L18.8874 8.8499L20.4437 9.48115L18.8124 9.88115L18.6937 11.5562L17.8124 10.1312L16.1812 10.5312L17.2624 9.2499L16.3749 7.83115L17.9312 8.4624L19.0124 7.18115Z"
              fill="#FFDA44"
            />{" "}
          </g>{" "}
          <defs>
            {" "}
            <clipPath id="clip0_20915_38677">
              {" "}
              <rect width="32" height="32" fill="white" />{" "}
            </clipPath>{" "}
          </defs>
        </svg>
      );

    case "flag_icon_ca":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_18949_46055)">
            <path
              d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
              fill="#F0F0F0"
            />
            <path
              d="M32 16C32 9.65664 28.3085 4.17565 22.9565 1.58765V30.4123C28.3085 27.8244 32 22.3434 32 16Z"
              fill="#D80027"
            />
            <path
              d="M0 16C0 22.3434 3.69156 27.8244 9.0435 30.4124V1.58765C3.69156 4.17565 0 9.65664 0 16Z"
              fill="#D80027"
            />
            <path
              d="M18.7826 18.087L21.5652 16.6957L20.1739 16.0001V14.6087L17.3913 16.0001L18.7826 13.2174H17.3913L16 11.1305L14.6087 13.2174H13.2174L14.6087 16.0001L11.8261 14.6087V16.0001L10.4348 16.6957L13.2174 18.087L12.5218 19.4783H15.3044V21.5652H16.6956V19.4783H19.4783L18.7826 18.087Z"
              fill="#D80027"
            />
          </g>
          <defs>
            <clipPath id="clip0_18949_46055">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "flag_icon_cz":
      return (
        <svg
          className={className}
          aria-label={altText}
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          {...svgAttributes}
        >
          <g clipPath="url(#clip0_3486_1244)">
            <rect x="-7.2002" y="-6.3999" width="68.8" height="22.4" fill="white" />
            <rect x="-7.2002" y="16" width="68.8" height="22.4" fill="#D2142E" />
            <path d="M16.7998 16.0001L-7.2002 -6.3999V38.4001L16.7998 16.0001Z" fill="#012681" />
          </g>
          <defs>
            <clipPath id="clip0_3486_1244">
              <rect width="32" height="32" rx="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    // === DEFAULT
    default:
      return null;
  }
};

export default IconOld;
